<template>
    <div>
        <b-row>
            <b-col>
                <b-form @submit.prevent="save">
                    <b-card>

                        <b-form-row>
                            <b-col cols="6" class="text-left">
                                <lg-finder-tipo-documento id="finderTipoDocumento"
                                    @onSelect="(item) => (form.tipoDocumento = item)" ref="finderTipoDocumento"
                                    title="Tipo Documento - LISTAR">
                                </lg-finder-tipo-documento>

                                <lg-form-input-finder v-model="form.tipoDocumento" fieldDescription="descricao"
                                    label="Tipo Documento*:" invalidFeedback=" " description="">
                                    <template #prepend>
                                        <b-button @click="$refs.finderTipoDocumento.show" class="btn-input-finder"
                                            pressed>
                                            <b-icon icon="search" />
                                        </b-button>
                                    </template>
                                </lg-form-input-finder>
                            </b-col>

                        </b-form-row>

                        <b-form-row>
                            <b-col cols="6" class="text-left">
                                <lg-finder-status id="finderStatus" @onSelect="(item) => (form.status = item)"
                                    ref="finderStatus" title="Status - LISTAR">
                                </lg-finder-status>

                                <lg-form-input-finder v-model="form.status" fieldDescription="descricao"
                                    label="Status*:" invalidFeedback=" " description="">
                                    <template #prepend>
                                        <b-button @click="$refs.finderStatus.show" class="btn-input-finder" pressed>
                                            <b-icon icon="search" />
                                        </b-button>
                                    </template>
                                </lg-form-input-finder>
                            </b-col>

                        </b-form-row>

                        <b-form-row class="mt-3">
                            <b-col cols="4" class="text-left">
                                <lg-form-input invalidFeedback="Informe o Nº Documento" description=""
                                    v-model="form.numero" label="Nº Documento*" maxlength="200" />
                            </b-col>
                        </b-form-row>



                        <b-form-row>
                            <b-col cols="6" class="text-left">
                                <lg-finder-local-armazenamento id="finderLocalArmazenamento"
                                    @onSelect="(item) => (form.localArmazenamento = item)"
                                    ref="finderLocalArmazenamento" title="Local Armazenamento - LISTAR">
                                </lg-finder-local-armazenamento>

                                <lg-form-input-finder v-model="form.localArmazenamento" fieldDescription="descricao"
                                    label="Local:" invalidFeedback=" " description="">
                                    <template #prepend>
                                        <b-button @click="$refs.finderLocalArmazenamento.show" class="btn-input-finder"
                                            pressed>
                                            <b-icon icon="search" />
                                        </b-button>
                                    </template>
                                </lg-form-input-finder>
                            </b-col>


                        </b-form-row>
                        <b-form-row>
                            <b-col cols="4" class="text-left">
                                <lg-form-date invalidFeedback="A data de deve ser informada!" description=""
                                    v-model="form.dataDocumento" label="Data do Documento*" />
                            </b-col>

                        </b-form-row>

                        <b-form-row>
                            <b-col cols="10" class="text-left">
                                <lg-form-input invalidFeedback="Informe a descrição" description=""
                                    v-model="form.descricao" label="Descrição:" maxlength="200" />
                            </b-col>
                        </b-form-row>

                        <b-form-row>
                            <b-col cols="11" class="text-right">
                                <label v-if="!form.arquivo" for="fileInput" class="file-label">
                                    <img :src="imgClip" class="img" alt="icone pdf" />
                                </label>
                                <input v-if="!form.arquivo" type="file" id="fileInput" @change="carregarDocumento"
                                    style="display: none;">
                                <img v-if="form.arquivo" :src="imgClip" class="img" alt="icone pdf"
                                    @click="mensagemErro" />



                            </b-col>
                        </b-form-row>
                        <b-form-row class="mt-1">
                            <b-col cols="12">
                                <b-table class="col-12" responsive="sm" stacked="sm" small outlined sticky-header
                                    show-empty head-variant="light" :busy="this.busy" :items="this.form.arquivo"
                                    :fields="itensFields">

                                    <template #table-busy>
                                        <div class="text-center text-primary my-2">
                                            <b-spinner class="align-middle"></b-spinner>
                                        </div>
                                    </template>

                                    <template #empty>
                                        <h6 style="text-align: center">
                                        </h6>
                                    </template>

                                    <template v-slot:cell(edit)>
                                        <b-icon class="hand-pointer" @click="apagar" icon="trash" font-scale="2" />

                                    </template>

                                </b-table>
                            </b-col>

                        </b-form-row>

                        <b-form-row>
                            <b-form-group label="Situação:*" label-for="radio" class="ml-3">

                                <b-form-row>
                                    <b-col cols="8">
                                        <b-form-radio-group id="radio" v-model="form.situacao" class="pt-2"
                                            :options="['Ativo', 'Inativo']"></b-form-radio-group>

                                    </b-col>
                                </b-form-row>
                            </b-form-group>

                        </b-form-row>

                    </b-card>
                </b-form>
            </b-col>
        </b-row>

        <div class="images-container" v-if="modal">
            <img :src="imgAceitar" class="img" alt="icone pdf" @click="salvar" />
            <img :src="imgFechar" class="img" alt="icone pdf" @click="fecharModal" />
        </div>

    </div>
</template>
<script>
import { getContext } from "@/core/auth";
import FecharIcon from "@/core/assets/icons/fechar.png";
import AceitarIcon from "@/core/assets/icons/aceitar.png";
import ClipIcon from "@/core/assets/icons/clip.png";
import LgFormInput from "@/core/components/Form/LgFormInput.vue";
import LgFormDate from "@/core/components/Form/LgFormDate.vue";
import LgFinderLocalArmazenamento from "@/components/Finders/LgFinderLocalArmazenamento.vue";
import LgFormInputFinder from "@/core/components/Form/LgFormInputFinder.vue";
import { FormResourceMixin, ListResourceMixin } from "@/core/mixins/resource";
import DocumentoIBPService from "@/core/api/DocumentoIBPService";
import LgFinderTipoDocumento from "@/components/Finders/LgFinderTipoDocumento.vue";
import LgFinderStatus from "@/components/Finders/LgFinderStatus.vue";

import moment from 'moment'
export default {
    components: {
        LgFormInput,
        LgFinderTipoDocumento,
        LgFinderLocalArmazenamento,
        LgFormDate,
        LgFormInputFinder,
        LgFinderStatus
    },
    mixins: [FormResourceMixin, ListResourceMixin],
    props: {
        id: Number,
        modal: Boolean,
        edicao: Boolean,
        idDocumento: Number
    },
    data() {
        return {
            imgAceitar: AceitarIcon,
            imgClip: ClipIcon,
            imgFechar: FecharIcon,
            itensFields: [
                {
                    key: 'titulo', label: 'Arquivo',
                    thStyle: "font-size: 14px; font-weight: 400;",
                    tdStyle: "font-size: 13px",
                },
                {
                    key: 'edit', label: ' ',
                    thStyle: "font-size: 14px; font-weight: 400;",
                    tdStyle: "font-size: 13px",

                },
            ],
            form: {
                descricao: '',
                numero: '',
                situacao: '',
                status: { id: null },
                dataDocumento: null,
                localArmazenamento: { id: null },
                tipoDocumento: { id: null },
                arquivo: null,
                itemBemPermanente: { id: null },

            },
        };
    },
    async beforeMount() {
        this.$documentoIBPService = new DocumentoIBPService();
        this.form.itemBemPermanente = { id: this.id }
        this.busy = false;
        let vm = this;

        if (this.edicao) {
            this.$documentoIBPService.findById(this.idDocumento).then(response => {
                vm.form = response.data;
                vm.form.situacao = vm.form.situacao == 1 ? "Ativo" : "Inativo";
                vm.form.arquivo = [{ titulo: vm.form.arquivo.nome, file: vm.montarArquivo(vm.form) }];
            })
        }


    },


    computed: {
        mostrarImagem() {
            return this.form.imagem && this.form.imagem != null;
        }
    },

    methods: {
        mensagemErro() {
            this.$notify({
                type: "danger",
                message: 'Nâo é possível anexar dois documentos',
            });

        },
        montarArquivo(item) {
            var binaryString = window.atob(item.arquivoBase64);
            var binaryLen = binaryString.length;
            var bytes = new Uint8Array(binaryLen);
            for (var i = 0; i < binaryLen; i++) {
                var ascii = binaryString.charCodeAt(i);
                bytes[i] = ascii;
            }
            return new Blob([bytes], { type: "application/rtf" });


        },
        apagar() {
            this.form.arquivo = null;
        },
        carregarDocumento(event) {

            if (this.form.arquivo) {
                this.mensagemErro();
                return;
            }


            var file = event.target.files[0];
            var nomeArquivo = file.name;
            if (file) {
                var reader = new FileReader();
                reader.onload = (e) => {
                    this.form.arquivo = [{ titulo: nomeArquivo, file: e.target.result }];
                };
                reader.readAsDataURL(file);
            }
        },

        dataURItoBlob(dataURI) {
            var byteString = atob(dataURI.split(',')[1]);
            var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
            var ab = new ArrayBuffer(byteString.length);
            var ia = new Uint8Array(ab);
            for (var i = 0; i < byteString.length; i++) {
                ia[i] = byteString.charCodeAt(i);
            }
            return new Blob([ab], { type: mimeString });
        },
        salvar() {

            if (!this.form.arquivo) {
                this.$notify({
                    type: "danger",
                    message: 'Selecione o documento',
                });

                return;
            }


            if (!this.form.tipoDocumento || this.form.tipoDocumento == '') {
                this.$notify({
                    type: "danger",
                    message: 'Tipo Documento é obrigatória',
                });

                return;
            }



            if (!this.form.numero || this.form.numero == '') {
                this.$notify({
                    type: "danger",
                    message: 'Nº documento é obrigatório',
                });

                return;
            }

            if (!this.form.dataDocumento) {
                this.$notify({
                    type: "danger",
                    message: 'Data do Documento é obrigatório',
                });

                return;
            }

            if (!this.form.localArmazenamento) {
                this.$notify({
                    type: "danger",
                    message: 'Local armazenamento é obrigatório',
                });

                return;
            }

            if (!this.form.situacao) {
                this.$notify({
                    type: "danger",
                    message: 'Situação é obrigatória',
                });

                return;
            }

            if (!this.form.status || !this.form.status.id) {
                this.$notify({
                    type: "danger",
                    message: 'Status é obrigatório',
                });

                return;
            }

            if (!this.form.descricao) {
                this.$notify({
                    type: "danger",
                    message: 'Descrição é obrigatória',
                });

                return;
            }

            this.form.itemBemPermanente = { id: this.id }

            var formData = new FormData();



            formData.append("status.id", this.form.status.id);

            formData.append("nomeArquivo", this.form.arquivo[0].titulo);
            formData.append("tipoDocumento.id", this.form.tipoDocumento.id);
            formData.append("localArmazenamento.id", this.form.localArmazenamento.id);
            formData.append("itemBemPermanente.id", this.form.itemBemPermanente.id);
            formData.append("respCriacao", getContext().usuario.nome);
            formData.append("situacao", this.form.situacao == 'Ativo' ? 1 : 0);
            formData.append("documento", this.dataURItoBlob(this.form.arquivo[0].file));
            formData.append("numero", this.form.numero);
            formData.append("descricao", this.form.descricao);
            formData.append("dataDocumentoFormatada", moment(String(this.form.dataDocumento)).format("DD/MM/YYYY"));



            if (this.edicao) {

                formData.append("cod", this.idDocumento);
                this.$documentoIBPService.editar(formData).then(response => {
                    this.$notify({
                        type: "success",
                        message: response.data,
                    });
                    this.fecharModal();
                }).catch(response => {
                    this.$notify({
                        type: "danger",
                        message: response.data,
                    });

                });
            }
            else {
                this.$documentoIBPService.salvar(formData).then(response => {
                    this.$notify({
                        type: "success",
                        message: response.data,
                    });
                    this.fecharModal();
                }).catch(response => {
                    this.$notify({
                        type: "danger",
                        message: response.data,
                    });

                });
            }

        },
        fecharModal() {
            this.$emit('fecharModal');
        },

        editar() {
            this.$notify({
                type: "danger",
                message: 'Esse registro não pode ser editado. Por favor, inclua um novo',
            });

        },

    },
};
</script>
<style>
.hand-pointer {
    cursor: pointer;
}
</style>